<template>
    <section class="hero">
        <div class="hero-body">
            <div class="column is-6-desktop is-offset-3-desktop is-10-tablet is-offset-1-tablet">
                <div class="box">
                    <form @submit.prevent="submit">
                        <h3 class="title is-spaced has-text-centered">GLEMT KODEORD</h3>

                        <p>
                            Hvis du har du glemt dit kodeord, kan du nulstille det ved at indtaste din email her.
                            <br> Vi sender dig en email med et link til at ændre det.
                        </p>

                        <br>

                        <b-notification :active.sync="success" type="is-success">
                            {{ success }}
                        </b-notification>

                        <b-field :label="$t('global.forms.email')"
                                 :type="{'is-danger': veeErrors.has('email')}"
                                 :message="veeErrors.first('email')">
                            <b-input v-model="email" type="email" name="email"
                                     v-validate="'required|email'" :data-vv-as="$t('global.forms.email')" />
                        </b-field>

                        <div class="buttons is-right margin-top-4rem">
                            <button type="submit" class="button is-primary" :disabled="veeErrors.any() && success" >
                                Send
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
    .hero {
        background: url('/static/backgrounds/white-bricks-people.jpeg') no-repeat center bottom;
        background-size: cover;
    }
</style>

<script>
    import ResetPasswordService from '@/infrastructure/auth/services/ResetPasswordService';

    export default {
        data() {
            return {
                email: null,
                success: null,
            };
        },

        mounted() {
            const { query } = this.$route;

            if (!query.reset) {
                return;
            }

            this.confirm(query.reset);
        },

        methods: {
            submit() {
                this.$validator.validateAll().then((result) => {
                    if (!result) {
                        return;
                    }

                    const data = { email: this.email };

                    ResetPasswordService.request(data, () => {
                        this.success = 'Hvis vi har en email der matcher den indtastede, har vi sendt en link til at ændre kodeord.';
                    }, () => {
                        this.success = 'Hvis vi har en email der matcher den indtastede, har vi sendt en link til at ændre kodeord.';
                    });
                });
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/infrastructure/auth/pages/RequestReset.vue